import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ToastInterface } from '~/component/toast/interfaces/toast.interface';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
})
export class ToastsComponent {
  @Input() public toastCollection: ToastInterface[] = [];

  @Output() public readonly closeToast = new EventEmitter<number>();

  public toastClosed(index: number): void {
    this.closeToast.emit(index);
  }
}
